import { StatModule } from "@/core/modules/stat/objects/StatModule";

import ExaminationScheduleView from "./views/ExaminationScheduleView.vue";

export const examinationSchedule: StatModule = new StatModule("examination", "ExaminationSchedule", "examination", ExaminationScheduleView);
